import React from 'react';
import Icon from '../../../components/AppIcon';

const ConfirmationSection = ({ candidate, referenceNumber }) => {
  return (
    <div className="bg-muted/30 rounded-xl p-6 mb-6 border border-border">
      <h4 className="font-medium text-foreground mb-4 flex items-center space-x-2">
        <Icon name="FileText" size={18} />
        <span>Purchase Summary</span>
      </h4>
      
      <div className="space-y-3">
        <div className="flex justify-between items-center py-2 border-b border-border">
          <span className="text-sm text-muted-foreground">Candidate Profile</span>
          <span className="text-sm font-medium text-foreground">{candidate?.title || 'Senior Developer'}</span>
        </div>
        
        <div className="flex justify-between items-center py-2 border-b border-border">
          <span className="text-sm text-muted-foreground">Reference Number</span>
          <span className="text-sm font-mono text-foreground">{referenceNumber}</span>
        </div>
        
        <div className="flex justify-between items-center py-2 border-b border-border">
          <span className="text-sm text-muted-foreground">Unlock Type</span>
          <span className="text-sm font-medium text-foreground">Full Contact Access</span>
        </div>
        
        <div className="flex justify-between items-center py-2">
          <span className="text-sm font-medium text-foreground">Total Amount</span>
          <span className="text-lg font-bold text-primary">149 kr</span>
        </div>
      </div>
      
      <div className="mt-4 pt-4 border-t border-border">
        <div className="flex items-start space-x-3 text-sm">
          <Icon name="Info" size={16} className="text-primary mt-0.5 flex-shrink-0" />
          <div className="text-muted-foreground">
            <div className="font-medium text-foreground mb-1">After payment completion:</div>
            <ul className="space-y-1 text-xs">
              <li>• Candidate contact information will be revealed immediately</li>
              <li>• You'll receive a confirmation email with all details</li>
              <li>• Direct messaging will be enabled with this candidate</li>
              <li>• Access is permanent - no recurring charges</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationSection;